import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import {
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  Excel32,
  JPG32,
  PNG32,
  PDF32,
  Approved32
} from "../../../../../public/LoginImages/importimages";

// 18-09
import BudgetEstimation from "../../BudgetManagement/BudgetEstimation/BudgetEstimation";



// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 
const BudgetEstimationList = () => {
  const context = useContext(AdminContext);
  const { GetAllBudgetEstimationList , Usermenu, GetBudgetEstimationList, BudgetEstimationApproval} = context;
  const [budgetEstimation, setBudgetEstimationList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  // 18-09
  const [menuData, setMenuData] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [editBudgetEstimationData, setEditBudgetEstimationData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const getBudgetEstimationList = async () => {
  let data = await GetAllBudgetEstimationList();
  console.log("data", data);
  const sortedData = [...data].sort(
    (a, b) => new Date(b.Date) - new Date(a.Date)
  );
  setBudgetEstimationList(sortedData);
  setFilteredBills(sortedData);
};
  useEffect(() => {
    getBudgetEstimationList();
  }, []);
  let budgetEstimationList = [];
  if (budgetEstimation.length > 0) {
    budgetEstimationList = budgetEstimation;
  }

  // above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = budgetEstimation.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, budgetEstimation]);
  const getBudgetEstimationPageNumbers = () => {
    const maxVisiblePages = 5;
 
    // 5 ya usse kam pages
    if (totalPages <= maxVisiblePages) {
        return Array.from(
            { length: totalPages },
            (_, index) => index + 1
        );
    }
 
    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
        return [1, 2, 3, 4, 5, "...", totalPages];
    }
 
    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
        return [
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
        ];
    }
 
    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
        "...",
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2,
        "...",
        totalPages
    ];
};
 


  // 18-09
  useEffect(() => {
  const getMenu = async () => {
    const res = await Usermenu();
    setMenuData(res?.Data || {});
  };
  getMenu();
}, []);

const isMaker =
  menuData?.Department_Name === "State Maker" &&
  menuData?.Role === "State Maker";

  const handleEditBudgetEstimation = (budgetEstimation) => {
  setEditBudgetEstimationData(budgetEstimation);
  setShowEditForm(true);
};

const handleApproveBudgetEstimation = async (budgetEstimation) => {
  const shouldProceed = window.confirm(
    "Are you sure you want to approve this Budget Estimation?"
  );

  if (!shouldProceed) return;

  try {
    console.log("🔥 APPROVE CLICKED");
    console.log("🔥 ID:", budgetEstimation.ID);
    console.log("🔥 Current Status:", budgetEstimation.Status);

    const response = await BudgetEstimationApproval(
      [budgetEstimation.ID],
      "Approved"
    );

    console.log("🔥 APPROVAL API RESPONSE:", response);

    if (response?.message) {
      alert(response.message);
    } else if (response?.error) {
      alert(response.error);
    }

    getBudgetEstimationList();
  } catch (err) {
    console.error("❌ Error approving Budget Estimation:", err);
    alert("An error occurred while approving.");
  }
};
return (
    <div
     style={{
        background: "#ffffff",
        width: "100%",
        minHeight: "calc(100vh - 80px)",
        overflowY: "auto",
        //29/10
        padding: "20px 30px 30px",
        boxSizing: "border-box",
        fontFamily: "Inter, sans-serif"
    }}
    > {!showEditForm ? (
      <div
         style={{
        width: "100%",
        maxWidth: "1300px",
        margin: "0 auto 10px",
        // display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxSizing: "border-box"
    }}
      >
         <div
      style={{
        width: "100%",
        background: "#EEF1F6",
        borderRadius: "12px",
        padding: "18px 15px",
        boxSizing: "border-box",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
        border: "1px solid #E1E6EF",
      }}
    >
        {/* ---- Header Section ---- */}
        <div
          style={{
            display: "flex",
            justifyContent:"space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >

         
          <h5
            style={{
              margin:0,
              fontSize:"18px",
              fontWeight: "700",
              color: "black",
            }}
          > <img
    src="/Project-Inward-List-32.png"
    alt="img"
   
  /> Budget Estimation Outward List </h5>

          {/* ---- Search Box ---- */}
           <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
          <div
          style={{
        display: "flex",
        alignItems: "center",
        width: "230px",
        height: "38px",
        backgroundColor: "#ffffff",
        border: "1px solid #d0d0d0",
        borderRadius: "7px",
        padding: "0 10px",
        boxSizing: "border-box"
    }}
          >
            <img
              src={"/Search-32.png"}
              alt="Search Icon"
              style={{ width: "18px", height: "18px", marginRight: "7px" }}
            />
            <input
              type="text"
              placeholder="Search Here..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                fontSize: "12px",
              }}
            />
          </div>
          <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    style={{
        width: "140px",
        height: "36px",
        marginLeft: "10px",
        border: "1px solid #d5dce5",
        borderRadius: "8px",
        padding: "0 10px",
        fontSize: "12px",
        outline: "none",
        background: "#fff",
        cursor: "pointer"
    }}
>
    <option value="All">All Status</option>
    <option value="Pending">Pending</option>
    <option value="SendBack">SendBack</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
</select></div>
        </div>


        <div     style={{
        width: "100%",
        maxWidth: "1300px",
        margin: "0 auto",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        padding: "14px",
        boxSizing: "border-box",
        overflow: "hidden"
         }}>
        {/* ---- Table Section ---- */}
        <div style={{
  width: "100%",
  // maxHeight: "360px",   
  overflowX: "auto",
  overflowY: "hidden",       
  marginTop: "8px",
  boxSizing: "border-box",
  border: "1px solid #d9e1f2",
  borderRadius: "8px",
  scrollbarWidth: "thin"
}}>
          <table
              style={{
                backgroundColor: "#ffffff",
                width: "100%",
                minWidth: "1000px",
                borderCollapse: "separate",  
borderSpacing: 0,             
                tableLayout: "auto",
              }}
            >
              <thead>
                <tr
                  style={{
                    //28/10 for table ui change
                  backgroundColor: "#2C7ADC",
                    color: "white",
                    border: "none",
                    height: "34px",
                    fontSize: "14px",
                    fontWeight: "600",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Sr.No</th>
                                    <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Financial Year</th>

                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Project ID</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Project Name</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Financial Year</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Budget ID</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>CRC</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Budget Head</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Object Code</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Esitmate Amount</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Date</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Remark</th>
                  <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Status</th>
                    {/* 18-09 */}
{isMaker && <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Action</th>}
{isMaker && <th style={{ padding: "10px", border: "1px solid #b8cfe0" }}>Approve</th>}

                </tr>
              </thead>

              {/* Single tbody, rendered exactly once regardless of data */}
              <tbody>
                {currentBills && currentBills.length > 0 ? (
                  currentBills.map((budgetEstimation, index) => (
                    <tr
                      key={index}
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                         backgroundColor: index % 2 === 0 ? "#E6F3FC" : "#CEE4F1",
                      }}
                    >
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {indexOfFirstBill + index + 1}
                      </td>
                       <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.Year}
                      </td>
                      <td style={{ padding: "10px",color:"#5295c9" }}>
                        {budgetEstimation.ProjectID}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.ProjectName}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.Year}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.BudgetID}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.CRC}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.BudgetHead}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.ObjectCode}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        ₹
                        {Number(
                          budgetEstimation.EsitmateAmount || 0,
                        ).toLocaleString("en-IN")}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.Date?.split("T")[0].replace(" ")}
                      </td>
                      <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.Remark?.trim() || "-"}
                      </td>
                        {/* <td style={{ padding: "10px", textAlign: "center",  border: "1px solid #b8cfe0", }}>
                        {budgetEstimation.Status?.trim() || "-"}
                      </td> */}

                        <td style={{ padding: "10px", textAlign: "center" }}>
  <StatusBadge status={budgetEstimation.Status} />
</td>
 
                       {/* 18-09 */}
                      {isMaker && (
                        <td style={{ padding: "10px", textAlign: "center" }}>
                          <button
                            onClick={() => handleEditBudgetEstimation(budgetEstimation)}
                            disabled={budgetEstimation.Status !== "SendBack"}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              margin: "auto",
                              padding: "6px 12px",
                              background:
                                budgetEstimation.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
                              color: "#fff",
                              border: "none",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: budgetEstimation.Status === "SendBack" ? "pointer" : "not-allowed",
                            }}
                          >
                            <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
                            Edit
                          </button>
                        </td>
                      )}
                      
                      {isMaker && (
                        <td style={{ padding: "10px", textAlign: "center" }}>
                          <button
                            onClick={() => handleApproveBudgetEstimation(budgetEstimation)}
                            disabled={budgetEstimation.Status !== "SendBack"}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              margin: "auto",
                              padding: "6px 12px",
                              background:
                                budgetEstimation.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
                              color: "#fff",
                              border: "none",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: budgetEstimation.Status === "SendBack" ? "pointer" : "not-allowed",
                            }}
                          >
                            <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
                            Approve
                          </button>
                        </td>
                      )}
                      
                    </tr>
                  ))
                ) : (
                  <tr>
                    
                  </tr>
                )}
              </tbody>
            </table>

            {/* 26-10 */}
              {currentBills.length === 0 && (
    <div
      style={{
        position: "sticky",
        left: 0,
        width: "100%",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#777",
        fontSize: "14px",
        fontWeight: "600",
      }}
    >
      No Data Found
    </div>
  )}
        </div>

        {/* ---- Pagination ---- */}
        <div
    style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: "15px",
        padding: "10px 5px",
        boxSizing: "border-box",
    }}
>
    {/* Showing Entries */}
    <div
        style={{
            fontSize: "13px",
            color: "#333",
            whiteSpace: "nowrap",
        }}
    >
        Showing{" "}
        {filteredBills?.length === 0
            ? 0
            : indexOfFirstBill + 1}{" "}
        to{" "}
        {Math.min(
            indexOfLastBill,
            filteredBills?.length || 0
        )}{" "}
        of {filteredBills?.length || 0} entries
    </div>
 
    {/* Pagination */}
    <div
        style={{
            display: "flex",
            alignItems: "center",
            gap: "18px",
        }}
    >
        {/* Previous */}
        <button
            onClick={() =>
                setCurrentPage((prev) =>
                    Math.max(prev - 1, 1)
                )
            }
            disabled={currentPage === 1}
            style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                    currentPage === 1
                        ? "not-allowed"
                        : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity:
                    currentPage === 1 ? 0.5 : 1,
            }}
        >
            ‹ Previous
        </button>
 
        {/* Page Numbers */}
   {/* Page Numbers */}
{/* Page Numbers */}
 
<div
    style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
    }}
>
    {getBudgetEstimationPageNumbers().map(
        (pageNumber, index) => {
 
            // Dots
            if (pageNumber === "...") {
                return (
                    <span
                        key={`ellipsis-${index}`}
                        style={{
                            fontSize: "13px",
                            color: "#444",
                        }}
                    >
                        ...
                    </span>
                );
            }
 
            // Page Number
            return (
                <button
                    key={pageNumber}
                    onClick={() =>
                        setCurrentPage(pageNumber)
                    }
                    style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        color:
                            currentPage === pageNumber
                                ? "#2ea4e7"
                                : "#444",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight:
                            currentPage === pageNumber
                                ? "600"
                                : "400",
                        textDecoration:
                            currentPage === pageNumber
                                ? "underline"
                                : "none",
                    }}
                >
                    {pageNumber}
                </button>
            );
        }
    )}
</div>
 
        {/* Next */}
        <button
            onClick={() =>
                setCurrentPage((prev) =>
                    Math.min(
                        prev + 1,
                        totalPages
                    )
                )
            }
            disabled={
                currentPage === totalPages ||
                totalPages === 0
            }
            style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                    currentPage === totalPages ||
                    totalPages === 0
                        ? "not-allowed"
                        : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity:
                    currentPage === totalPages ||
                    totalPages === 0
                        ? 0.5
                        : 1,
            }}
        >
            Next ›
        </button>
    </div>
</div>
 

        </div>
      </div></div>
       ) : (
      <BudgetEstimation
        isEdit={true}
        BudgetEstimationData={editBudgetEstimationData}
        onSuccess={() => {
          setShowEditForm(false);
          getBudgetEstimationList();
        }}
        onCancel={() => {
          setShowEditForm(false);
        }}
      />
    )}
    </div>
  );
};

export default BudgetEstimationList;
